export default {
    redeem_now: 'استبدل الآن',
    browse_ecocredits_rewards: 'تصفَّح مكافآت EcoCredits',
    profile_detail:
        'أكمِل ملفك الشخصي لتحصل على ما يصل إلى 1000 نقطة، بما في ذلك صورة الملف الشخصي (200 نقطة)، واسم المستخدم (100 نقطة)، وبيانات الاتصال (300 نقطة)، والعنوان (200 نقطة)، وتاريخ الميلاد (200 نقطة).',
    confirm_text: 'هل أنت واثق بأنك تريد الاستبدال؟ هذه الخطوة لا يمكن الرجوع فيها.',
    login: 'تسجيل الدخول',
    refund: 'رد المبلغ المدفوع',
    history_note: 'ستظهر النقاط التي تحصل عليها هنا. ألا ترى نقاطك؟ سيتم تحديث نشاطك في خلال 24 ساعة.',
    already_member: 'هل أنت عضو بالفعل؟',
    already_member1: 'هل أنت عضو بالفعل؟',
    points: 'النقاط',
    warranty_capital_letters: 'الضمان',
    action: 'الإجراء',
    available: 'متاح',
    faq_title: 'الأسئلة الشائعة',
    product_rules: 'لمنتج {product} فقط.',
    view_more: 'عرض المزيد',
    points_capital_letters: 'النقاط',
    complete_profile: 'الملف الشخصي مكتمل',
    referral: 'INVITE A FRIEND',
    referral_desc: 'Earn EcoCredits for each friend who successfully signs up.',
    referral_btn: 'Join Now',
    minimum_price: 'الحد الأدنى لمبلغ الشراء ({price}).',
    off: 'إيقاف التشغيل',
    days_rules: 'يمكن استخدامها خلال {days} من الأيام عند الاستبدال.',
    join_subTitle: 'سجِّل نفسك عضوًا في مجتمعنا لكسب النقاط والمكافآت الحصرية كلما تسوَّقت على موقعنا.',
    current_tier: 'المستوى الحالي',
    purchas_rule: 'شراء منتج بثمن أقل من قيمة الكوبون (الكوبونات) سيجعلك تفقد باقي قيمة الكوبون.',
    site_rules: 'لمتاجر المملكة المتحدة فقط.',
    subscribe_hover: 'اكسب 500 نقطة عند انضمامك.',
    profile_address: 'الملف الشخصي - العنوان',
    benefits_item7: 'استبدال النقاط بهدايا مميزة',
    benefits_item6: 'الفوائد التي يمكن الحصول عليها من شركائنا',
    earn_point_rule_shop: 'احصل على نقطة مقابل كل جنيه إسترليني تنفقه.',
    received: 'تم الاستلام',
    profile_birthday: 'الملف الشخصي - تاريخ الولادة',
    shop: 'التسوُّق',
    earn_point_by_order: 'اكسب في كل مرة تطلب فيها.',
    shop_capital_letters: 'التسوُّق',
    redeem_ecocredits_title: 'استبدال مكافآت EcoCredits',
    rules: 'القواعد',
    subscribe_text: 'اشترك للحصول على رسائل EcoFlow الإخبارية.',
    pending: 'قيد الانتظار',
    welcome_sub_title: 'مرحبًا بك في برنامج المكافآت EcoCredits.',
    redeem_points: 'استبدال النقاط',
    sign_up: 'الاشتراك',
    redeem_points_desc: 'اجمع النقاط للحصول على خصومات حصرية.',
    earn_points: 'كسب النقاط',
    earn_points_desc: 'اكسب نقاطًا في كل مرة تتسوق فيها.',
    sign_up_desc: 'أنشئ حسابًا واحصل على مكافأة بمقدار 500 نقطة.',
    no_history_note: 'ألم ترَ النقاط التي كسبتها بعد؟ سيتم تحديث نشاطك خلال 24 ساعة.',
    no_enough_points: 'لم ينجح الاستبدال، فنقاطك غير كافية',
    see_t_c: 'اطلع على الشروط والأحكام',
    membership_faq_title: 'العضوية',
    email_address: 'عنوان البريد الإلكتروني',
    redeemed: 'تم الحصول عليها',
    manually_added: 'تمت الإضافة يدويًا',
    have_points: 'لديك <code>{points} من النقاط</code>',
    learn_more: 'اعرف المزيد',
    add_your_birthday: 'أضف تاريخ ميلادك',
    earning_points: 'كسب النقاط',
    or_text: 'أو',
    join_title: 'انضم إلى برنامج المكافآت EcoCredits',
    copy_desc: 'لقد نسخت الرمز. يُرجى الانتقال إلى المتجر لاستخدامه.',
    manually_deducted: 'تم الخصم يدويًا',
    join_now: 'انضم الآن',
    warranty: 'الضمان',
    status: 'الحالة',
    birthday: 'يوم الميلاد',
    points_balance: 'توازن النقاط',
    points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
    shop_to_earn_points: 'تسوق لتكسب نقاطًا',
    stay_too_long: 'انتهت صلاحية جلستك. يُرجى تحديث الصفحة والمحاولة مرة أخرى.',
    subscribe_now: 'اشترك الآن',
    exceeded_counts: 'فشل في استخدام النقاط. لقد تجاوزت حد استخدام النقاط.',
    coming_soon: 'قريبًا',
    points_activity: 'نشاط النقاط',
    login_capital_letters: 'تسجيل الدخول',
    login_capital_letters1: 'تسجيل الدخول',
    profile_username: 'الملف الشخصي - اسم المستخدم',
    rewards_redeemed: 'تم الحصول على الجوائز',
    expired: 'منتهي الصلاحية',
    minimum_num: 'الحد الأدنى لعدد العناصر ({num} من القطع).',
    coupon: 'رمز الخصم',
    subscribe: 'اشتراك',
    gift_card: 'بطاقة هدية',
    profile: 'الملف الشخصي',
    deducted: 'تم الخصم',
    registered: 'مسجل',
    birthday_placeholder: 'اليوم/الشهر/السنة',
    give_away: 'منح',
    discount: 'خصم',
    edeemed_rewards_note: 'ستظهر الجوائز التي حصلت عليها هنا.',
    completed_text: 'لقد حققت هذه المكافأة بالفعل.',
    points_activity_a: 'نشاط النقاط',
    earn_points_title: 'طرق لتكسب نقاطًا',
    profile_picture: 'الملف الشخصي - الصورة',
    days_rules2: 'صالح من {data}.',
    purchase: 'الشراء',
    used: 'مُستخدَم',
    network_error: 'خطأ في الشبكة',
    confirm_btn: 'تأكيد',
    sign_up_text: '500 نقطة عند الانضمام',
    profile_contact: 'الملف الشخصي - معلومات التواصل',
    membership_includes: 'تتضمن العضوية',
    summary_text: 'ملخص نقاطك من EcoCredits',
    store: 'تسوق الآن',
    sign_up_desc_h: '500 نقطة عند انضمامك.',
    warranty_desc2: '1000 نقطة عندما تسجّل منتجًا.',
    warranty_desc1: '1000 نقطة عندما تسجّل منتجًا.',
    order_rule: 'رمز خصم واحد فقط لكل طلب.',
    ecoflow_benefits: 'مزايا EcoCredits لعام ',
    redeeming_points: 'استرداد النقاط',
    coupon_used_desc: 'استخدم هذا الرمز عند إتمام الشراء لتحصل على بطاقة هديتك بقيمة {amont}.',
    add_my_birthday: 'إضافة تاريخ ميلادي',
    date: 'التاريخ',
    profile_desc1: 'اكسب ما يصل إلى 1000 نقطة مقابل استكمال ملفك الشخصي.',
    profile_desc2: 'احصل على ما يصل إلى 1000 نقطة مقابل إضافة تفاصيلك.',
    view_all: 'عرض الكل',
    send_your_friend: 'أرسل بطاقة هديتك بقيمة {amont} إلى صديق.',
    subscribe_capital_letters: 'اشتراك',
    no_coupon_note: 'لم يتم الحصول على جوائز بعد.',
    redeemed_succ: 'تم الحصول بنجاح!',
    birthday_desc2: 'اكسب {points} من النقاط عندما تضيف تاريخ ميلادك.',
    birthday_desc1: 'أضف تاريخ ميلادك للحصول على نقاط.',
    profile_a: 'الملف الشخصي',
    event_action_text: 'Event',
    warranty_minus_action_text: 'Warranty Deleted',
    question_correctly: 'Answer the question correctly',
    follow_instagram_text: 'Follow Instagram',
    follow_x_text: 'Follow X',
    follow_youtube_text: 'Follow YouTube',
    follow_facebook_text: 'Follow Facebook',
    join_facebook_text: 'Join Us On Facebook',
    confirm_btn_text: 'OK',
    points_cash: 'Points Redemption',
    Pending1: 'Pending',
    rollback: 'Returned',
    level_change_log: 'Tier Activity',
    deadline: 'Valid Until',
    history_refresh_member: 'Current Tier: Member',
    history_refresh_plus_member: 'Current Tier: PLUS Member',
    register: 'Register as a Member',
    upgrade: 'Upgrade to PLUS Member',
    demotion: 'Downgrade to Member',
    relegation: 'Maintain as PLUS Member',
    wattayear_2024: 'Share#WattAYear',
    site_account_profile_save_success: 'Success',
    not_eligible: 'You are not eligible to participate in this event.',
};
